import { createSelector } from 'reselect'

import {
  props,
  networkProps,
  networkErrors,
  networkLoading,
} from './utils'

import {
  getIdMap,
} from 'utils/object'

import subscriptionUtils from 'utils/subscription'

const sortByOrder = (a, b) => {
  const aOrder = a.metadata.order
  const bOrder = b.metadata.order

  if(aOrder > bOrder) return 1
  else if(aOrder < bOrder) return -1
  else return 0
}

const loaded = state => state.payment.loaded
const products = state => state.payment.products
const customer = state => state.payment.customer
const invoices = state => state.payment.invoices
const card = state => state.payment.card
const cancelledSubscriptions = state => state.payment.cancelledSubscriptions
const cancelledSubscriptionInvoices = state => state.payment.cancelledSubscriptionInvoices
const changePlanInfo = state => state.payment.changePlanInfo

const productMap = createSelector(
  products,
  products => getIdMap(products),
)

const subscriptions = createSelector(
  customer,
  customer => customer ? customer.subscriptions.data : [],
)

const subscription = createSelector(
  subscriptions,
  subscriptions => subscriptions.find(s => s.status == 'active')
)

const subscriptionItems = createSelector(
  subscription,
  subscription => {
    if(!subscription) return []
    return subscription.items.data || []
  }
)

const subscriptionPrices = createSelector(
  subscriptionItems,
  subscriptionItems => subscriptionItems.map(i => i.price)
)

const subscriptionTable = createSelector(
  subscription,
  productMap,
  (subscription, productMap) => subscriptionUtils.getSubscriptionTable(subscription, productMap)
)

const subscriptionInfo = createSelector(
  subscription,
  productMap,
  (subscription, productMap) => subscriptionUtils.getSubscriptionInfo(subscription, productMap)
)

const defaultProduct = createSelector(
  products,
  products => products.find(p => p.metadata.default)
)

const sortedProducts = createSelector(
  products,
  products => [].concat(products).sort(sortByOrder)
)

const currentPlan = createSelector(
  products,
  defaultProduct,
  subscriptionPrices,
  (products, defaultProduct, subscriptionPrices) => {
    const productsById = getIdMap(products)
    const matchingPrice = subscriptionPrices.find(price => productsById[price.product])
    const matchingProduct = matchingPrice ? productsById[matchingPrice.product] : null
    return matchingProduct || defaultProduct
  }
)

const dedicatedProducts = createSelector(
  products,
  products => products.filter(p => p.metadata.hardware == 'dedicated').sort(sortByOrder)
)

const subscriptionQuantities = createSelector(
  subscriptionItems,
  productMap,
  (items, productMap) => {
    return items.reduce((all, item) => {
      all[item.price.product] = item.quantity
      return all
    }, {})
  }
)

const NETWORK_NAMES = networkProps('payment', [
  'loadProducts',
])

const selectors = {
  loaded,
  products,
  sortedProducts,
  customer,
  invoices,
  card,
  productMap,
  subscriptions,
  subscription,
  subscriptionItems,
  subscriptionPrices,
  subscriptionTable,
  subscriptionQuantities,
  subscriptionInfo,
  defaultProduct,
  currentPlan,
  cancelledSubscriptionInvoices,
  changePlanInfo,
  cancelledSubscriptions,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
}

export default selectors
